import numWords from "num-words";

export function numberToWord(numberValue: number): string | null {
  try {
    return numWords(numberValue);
  } catch (_) {
    return null;
  }
}
